<div>
  <p-dropdown
    *ngIf="!(productsLoading$ | async); else productsLoading"
    [options]="(selectableProducts$ | async)!"
    [ngModel]="selectedProduct$ | async"
    (onChange)="setProduct($event)"
    optionLabel="name"
    placeholder="Produkt wählen"
    styleClass="w-full"
    scrollHeight="250px"
    appendTo="body"
  ></p-dropdown>
  <ng-template #productsLoading>
    <p-skeleton height="42px"></p-skeleton>
  </ng-template>
</div>
